import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Heart, Gamepad2, BookOpen, Award } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    icon: Calendar,
    title: '30-DAY FOCUS PLANNER',
    desc: 'The number one reason parents never see results with activity kits is the lack of a plan. The 30-Day Focus Planner gives you a pre-built printable roadmap telling you exactly which activity to print each day. No thinking required.',
    value: '$17'
  }, {
    num: '02',
    icon: Heart,
    title: 'EMOTION CONTROL FOR KIDS',
    desc: 'A child who cannot manage emotions cannot focus. Simple printable exercises, feeling charts, and guided reflection pages to help children identify what they feel and how to reset in under 60 seconds.',
    value: '$17'
  }, {
    num: '03',
    icon: Gamepad2,
    title: 'SCREEN-FREE PLAYBOOK',
    desc: 'A practical PDF packed with simple offline games, attention-building mini challenges, and family interaction prompts that extend the benefits beyond the printed pages. Perfect for weekends and car rides.',
    value: '$17'
  }, {
    num: '04',
    icon: BookOpen,
    title: 'PARENT QUICK-START GUIDE',
    desc: 'Walks you through the entire system in 15 minutes. Learn which tome to start with, how to build a 10-minute daily ritual, and what to say when your child resists. Read it once. Use it forever.',
    value: '$17'
  }, {
    num: '05',
    icon: Award,
    title: 'FOCUS REWARDS SYSTEM',
    desc: 'Adds a powerful gamification layer. Printable reward charts, achievement trackers, and a badge progression system that makes your child want to complete activities instead of avoiding them.',
    value: '$17'
  }];
  return <section className="bg-navy py-16 px-4" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-white mb-3" data-id="element-20">
            🎁 5 EXCLUSIVE BONUSES
          </h2>
          <p className="text-lg md:text-xl text-orange font-bold tracking-widest uppercase" data-id="element-21">
            Included Today
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-22">
          {bonuses.map((bono, i) => <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={i} className="bg-navy-dark rounded-xl p-6 flex flex-col md:flex-row items-center border border-white/10 shadow-lg" data-id="element-23">
              <div className="flex-shrink-0 w-16 h-16 bg-orange/10 rounded-full flex items-center justify-center text-orange mb-4 md:mb-0 md:mr-6 border border-orange/30" data-id="element-24">
                <bono.icon className="w-8 h-8" data-id="element-25" />
              </div>
              <div className="flex-grow text-center md:text-left mb-4 md:mb-0" data-id="element-26">
                <h4 className="text-lg md:text-xl font-heading font-bold text-white mb-2 flex items-center justify-center md:justify-start" data-id="element-27">
                  <span className="mr-2 text-orange" data-id="element-28">🎁</span> BONUS {bono.num}:{' '}
                  {bono.title}
                </h4>
                <p className="text-white/80 text-sm md:text-base font-medium" data-id="element-29">
                  {bono.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-center md:text-right md:ml-6 bg-navy px-4 py-3 rounded-lg border border-white/10" data-id="element-30">
                <p className="line-through text-sm mb-1 text-white/50 font-medium" data-id="element-31">
                  Value: {bono.value}
                </p>
                <p className="text-green font-bold text-xl" data-id="element-32">FREE</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}